<template lang="pug">
  section.section-4
    .block-wrap
      .h3.headline {{ gettext('What people say about us') }}
      .slider
        .swap-container
          .slide
            .left
              .avatar-wrap
                .avatar(style="background-image: url(/webapp/images/home/avatar.png)")
            .right
              i.mdi.mdi-format-quote-close.quote
              p "{{ gettext('I can warmly recommend Bixter.work. It can be really hard for a foreigner to find a well-paid job abroad if you do not have any local friends or relatives. But I got several offers from Bixter when I contacted them and I could choose the one that was closer to the place where my husband works. They helped with CV and other papers so I just need to come to an interview. And Ta-da I am working now legally in Denmark. Thank you one more time') }}"
              p.author
                span - {{ gettext('Maria Sirotskaya') }}
                a(:href="links[getLanguage] || links['en']").main-btn.bg-red.col-white {{ gettext('See more') }}
</template>

<script>
import { gettext } from '@/services/TranslateHandler'
import { mapGetters } from 'vuex'

export default {
  name: 'testimonials',
  data () {
    return {
      links: {
        en: 'http://bixter.com/testimonials-en/',
        da: 'http://bixter.com/testimonials-dk/',
        de: 'http://bixter.com/testimonials-de/',
        ru: 'http://bixter.com/testimonials-ru/',
        uk: 'http://bixter.com/testimonials-ua/',
        ro: 'http://bixter.com/testimonials-ro/'
      }
    }
  },
  methods: {
    gettext: gettext
  },
  computed: {
    ...mapGetters(['getLanguage'])
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/home/parts/testimonials/index.vue